// extracted by mini-css-extract-plugin
export default {"exam-section":"arrow_exam-section__gX36F","arrow":"arrow_arrow__1OotW","left":"arrow_left__d2QMQ","right":"arrow_right__9mQvG"};